module.exports = __webpack_public_path__ + "media/images/lp/industries/img-wave02-c200e07e50908d9b80b857b152639f4e.svg";